import axios from 'axios';
import qs from 'qs';

export const getStudentReviews = (params: Record<string, any>) =>
  axios.get(`/api/v1/student-reviews?${qs.stringify(params)}`);

export const getStudentReviewsByStudentId = ({
  studentId,
  params,
}: {
  studentId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/student-reviews/students/${studentId}?${qs.stringify(params)}`,
  );
